// extracted by mini-css-extract-plugin
export default {"classCardsList":"ClassCardsList_classCardsList__ogOuZ","classFormCard":"ClassCardsList_classFormCard__XSqtN"};